import React from 'react';
import { format } from 'date-fns';
import { Select } from 'semantic-ui-react';

const options = [
    {
        value: 'hh:mm a',
        text: 'hh:mm a',
        description: format(new Date(), 'hh:mm a'),
    },
    {
        value: 'HH:mm',
        text: 'HH:mm',
        description: format(new Date(), 'HH:mm'),
    },
];

function TimeFormatSelect({ meta: _meta, ...props }) {
    return <Select options={options} {...props} />;
}

export default TimeFormatSelect;
